import {UserGroup} from '@/services/graphqlHooks';
import isGroupAuthorized from '@/utils/isGroupAuthorized';

export const optionalWorkTimeTrackingGroups = [
  UserGroup.Admins,
  UserGroup.Moderators,
  UserGroup.EmployeesInventory,
];

export const forcedWorkTimeTrackingGroups = [UserGroup.Employees];

export const workTimeTrackingGroups = [
  ...optionalWorkTimeTrackingGroups,
  ...forcedWorkTimeTrackingGroups,
];

export function isEmployeeWorkTimeTrackingForced(
  groups: UserGroup[],
  forceTrackingEnabled: boolean
) {
  return (
    forceTrackingEnabled &&
    isGroupAuthorized(groups, forcedWorkTimeTrackingGroups)
  );
}

export function shouldShowWorkTimeTrackingReminder(
  groups: UserGroup[],
  forceTrackingEnabled: boolean
) {
  return (
    forceTrackingEnabled &&
    isGroupAuthorized(groups, optionalWorkTimeTrackingGroups)
  );
}
